import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { useFlairBreadcrumbHook } from '../../../../hooks/useFlairBreadcrumbHook';
import { useNamespacedTranslation } from '../../../../hooks/useNamespacedTranslation';
import { ObjectiveMode } from '../../__generated__/graphql';
import { EmployeesObjectiveAchievement } from '../../pages/PerformanceReview/EmployeesObjectiveAchievement';
import { PeriodDropdown } from '../../pages/PerformanceReview/Goals2/GoalPeriodSelector/PeriodDropdown';
import {
  GoalsContextProvider,
  useGoalsContext,
} from '../../pages/PerformanceReview/Goals2/GoalsContext/GoalsContext';

const i18Path = 'goalsOverview';

const GoalsOverviewContent: React.FC = () => {
  const tNav = useNamespacedTranslation('navigation.menuItems.teamDevelopment');
  const t = useNamespacedTranslation(i18Path);

  useFlairBreadcrumbHook([
    { label: tNav('title') },
    { label: t('breadcrumb') },
  ]);

  const {
    allActivePeriods,
    currentPeriod,
    setCurrentPeriodId,
    loading,
    objectiveMode,
  } = useGoalsContext();

  if (loading) {
    return (
      <div className="mt-2">
        <Skeleton height={40} width={300} className="mb-3" />
        <Skeleton count={5} height={50} className="mb-2" />
      </div>
    );
  }

  if (allActivePeriods.length === 0) {
    return (
      <div className="mt-2">
        <h1 className="header-title">{t('title')}</h1>
        <p className="text-muted">{t('noActivePeriods')}</p>
      </div>
    );
  }

  return (
    <div className="mt-2">
      <div className="mb-4">
        <PeriodDropdown
          periods={allActivePeriods}
          currentPeriod={currentPeriod}
          onSelect={setCurrentPeriodId}
          selectLabel={t('selectPeriod')}
        />
      </div>

      {currentPeriod &&
        (objectiveMode === ObjectiveMode.Mbo ? (
          <EmployeesObjectiveAchievement
            objectiveTimePeriodId={currentPeriod.Id}
          />
        ) : (
          <p className="text-muted">{t('scoringOnlyMbo')}</p>
        ))}
    </div>
  );
};

export const GoalsOverviewPage: React.FC = () => {
  return (
    <GoalsContextProvider isManagerView>
      <GoalsOverviewContent />
    </GoalsContextProvider>
  );
};
